<template>
    <v-container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">
        <v-layout column fill-height>
            <div style="width:100%;height:48px;display:flex;align-items:center;">
                <v-radio-group v-model="dataType" row style="display:flex;justify-content:flex-end;align-items:center;">
                    <v-radio flat value="values" label="Values" color="rgb(51,82,128)"/>
                    <v-radio flat value="diff" label="Diff. %" color="rgb(51,82,128)"/>
                </v-radio-group>
            </div>
            <v-layout row>
                <v-flex d-flex md6>
                    <v-layout column fill-height>
                        <!-- <v-flex d-flex md3 style="max-height:25%;">
                          <TimelineChart
                            v-if="chartData['ensp']"
                            v-bind:active="active"
                            v-bind:chartOptions="chartData['ensp']"
                            v-bind:title="titles['ensp']"/>
                        </v-flex> -->
                        <v-flex ref="tlChart" d-flex md3 style="max-height:25%;">
                            <TimelineChart
                                    v-if="chartData['pcomp']"
                                    v-bind:active="active"
                                    v-bind:chartOptions="chartData['pcomp']"
                                    v-bind:title="titles['pcomp']"/>
                        </v-flex>
                        <v-flex d-flex md3 style="max-height:25%;">
                            <TimelineChart
                                    v-if="chartData['pmax']"
                                    v-bind:active="active"
                                    v-bind:chartOptions="chartData['pmax']"
                                    v-bind:title="titles['pmax']"/>
                        </v-flex>
                        <v-flex d-flex md3 style="max-height:25%;">
                            <TimelineChart
                                    v-if="chartData['tTurbIn']"
                                    v-bind:active="active"
                                    v-bind:chartOptions="chartData['tTurbIn']"
                                    v-bind:title="titles['tTurbIn']"/>
                        </v-flex>
                        <v-flex d-flex md3 style="max-height:25%;">
                            <TimelineChart
                                    v-if="chartData['tcspeed']"
                                    v-bind:active="active"
                                    v-bind:chartOptions="chartData['tcspeed']"
                                    v-bind:title="titles['tcspeed']"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex d-flex md6>
                    <v-layout column fill-height>
                        <v-flex d-flex md3 style="max-height:25%;">
                            <TimelineChart v-if="chartData['pscav']" v-bind:active="active" v-bind:chartOptions="chartData['pscav']" v-bind:title="titles['pscav']"/>
                        </v-flex>
                        <v-flex d-flex md3 style="max-height:25%;">
                            <TimelineChart v-if="chartData['tscav']" v-bind:active="active" v-bind:chartOptions="chartData['tscav']" v-bind:title="titles['tscav']"/>
                        </v-flex>
                        <v-flex d-flex md3 style="max-height:25%;">
                            <TimelineChart v-if="chartData['soPresDispl']" v-bind:active="active" v-bind:chartOptions="chartData['soPresDispl']" v-bind:title="titles['soPresDispl']"/>
                        </v-flex>
                        <v-flex d-flex md3 style="max-height:25%;">
                            <TimelineChart v-if="chartData['fRailPres']" v-bind:active="active" v-bind:chartOptions="chartData['fRailPres']" v-bind:title="titles['fRailPres']"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-container>

</template>

<script>

    import TimelineChart from '../controls/TimelineChart'

    import {globalStore, vessels} from "../main.js"

    export default {
        name: 'EngineGraphs',
        components: {
            TimelineChart
        },
        props: {
            active: Boolean
        },
        data() {
            return {
                chartData: {},
                dataType: 'values',
                titles: {}
            }
        },
        mounted() {
            var mapping = globalStore.mapping[globalStore.selectedIMO];

            if (typeof mapping == 'undefined') {
                mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
            }

            let params = ['ensp', 'load', 'pcomp', 'pmax', 'tcspeed', 'tscav', 'tTurbIn', 'pscav', 'soPresDispl', 'fRailPres'];

            for (let p = 0; p < params.length; p++) {
                this.$set(this.titles, params[p], mapping['mapping'][params[p]]);
            }

            this.setData();

        },
        methods: {
            average: function (param, count, data, timestamp) {
                let sum = 0;

                for (let i = 1; i <= count; i++) {
                    if (data[timestamp][param + i] != -1000) sum += data[timestamp][param + i];
                    else count--;
                }

                if ((sum == 0) || (count == 0)) return -1000;
                else return sum / count;
            },
            setData() {
                if (this.dataType == 'values') this.setValuesData();
                else this.setDiffData();
            },
            setValuesData() {
                var units = globalStore.units[globalStore.selectedIMO],
                    limits = globalStore.limits[globalStore.selectedIMO];

                if (typeof units == 'undefined') {
                    units = globalStore.units[Object.keys(globalStore.units)[0]]
                }

                if (typeof limits == 'undefined') {
                    limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
                }

                let cylCount = 6,
                    tcCount = 1;

                if (globalStore.selectedVessel != 'Energy Triumph') tcCount = 2;

                let timeStamps = Object.keys(globalStore.signals);

                if (timeStamps.indexOf('average') > -1)
                    timeStamps.splice(timeStamps.indexOf('average'), 1);

                let params = ['pcomp', 'pmax', 'tcspeed', 'tscav', 'tTurbIn', 'pscav', 'soPresDispl', 'fRailPres', 'ensp', 'load'],
                    elCount = [cylCount, cylCount, tcCount, 0, tcCount, 0, 0, 0, 0, 0],
                    refs = ['pcomp', 'pmax', 'tcspeed', 'tscav', 'tTurbIn', 'pscav', 'soPresSetpoint', 'fRailPresSet', 'ensp', 'load'];

                for (let p = 0; p < params.length; p++) {
                    this.$set(this.chartData, params[p], {
                        credits: {enabled: false},
                        time: {
                            useUTC: false
                        },
                        chart: {
                            height: 100,
                            zoomType: 'xy'
                        },
                        xAxis: {
                            type: 'datetime',
                            title: {
                                text: 'Time',
                                align: 'high'
                            },
                            labels: {
                                format: '{value:%H:%M}'
                            },
                            crosshair: true
                        },
                        yAxis: {
                            title: {
                                text: '[' + units[params[p]] + ']',
                                align: 'high'
                            }
                        },
                        exporting: {
                            enabled: false
                        },
                        tooltip: {
                            formatter: function () {
                                return this.points.reduce(function (s, point) {
                                    if (point.series.type == 'line') {
                                        return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                                    }
                                    else {
                                        return s + '<br/>' + point.series.name + ': from ' + point.point.low.toFixed(2) + ' to ' + point.point.high.toFixed(2);
                                    }
                                }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
                            },
                            shared: true
                        },
                        legend: {
                            enabled: false
                        },
                        title: {
                            text: undefined
                        },
                        series: [
                            {
                                name: 'Value',
                                type: 'line',
                                color: 'transparent',
                                animation: false,
                                data: [],
                                marker: {
                                    radius: 3
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    },
                                    normal: {
                                        animation: false
                                    },
                                    inactive: {
                                        opacity: 1
                                    }
                                }
                            },
                            {
                                name: 'Acceptable Range',
                                type: 'arearange',
                                animation: false,
                                data: [],
                                marker: {
                                    enabled: false
                                },
                                color: 'rgb(219, 219, 219)',
                                fillOpacity: 0.6,
                                states: {
                                    hover: {
                                        enabled: false
                                    },
                                    normal: {
                                        animation: false
                                    },
                                    inactive: {
                                        opacity: 1
                                    }
                                }
                            }
                        ]
                    });

                    for (let i = 0; i < timeStamps.length; i++) {
                        let val, rfr;

                        if (elCount[p] == 0)
                            val = globalStore.signals[timeStamps[i]][params[p]];
                        else
                            val = this.average(params[p], elCount[p], globalStore.signals, timeStamps[i]);

                        if (params[p] == 'fRailPres')
                            rfr = globalStore.signals[timeStamps[i]][refs[p]];
                        else if (Object.keys(globalStore.reference).includes(timeStamps[i])) {
                            if (elCount[p] == 0)
                                rfr = globalStore.reference[timeStamps[i]][refs[p]];
                            else
                                rfr = this.average(refs[p], elCount[p], globalStore.reference, timeStamps[i]);
                        } else
                            rfr = -1000;

                        let color = 'rgb(51,82,128)',
                            dt = new Date(timeStamps[i]);

                        if ((val != -1000) && (rfr != -1000) && (Object.keys(limits).includes(params[p]))) {
                            let minLimit = limits[params[p]][0], maxLimit = limits[params[p]][1];

                            if ((minLimit != null) && (maxLimit != null)) {

                                let temp = ((val - rfr) / val) * 100;

                                if ((temp > minLimit) && (temp < maxLimit)) color = 'rgb(60, 171, 48)';
                                else color = 'rgb(205, 57, 64)';

                                let min = rfr / (1 - minLimit / 100);
                                let max = rfr / (1 - maxLimit / 100);

                                this.chartData[params[p]].series[1].data.push({
                                    x: dt,
                                    low: min,
                                    high: max
                                });
                            }
                        }

                        if (val != -1000)
                            this.chartData[params[p]].series[0].data.push({
                                x: dt,
                                y: val,
                                color: color
                            });
                    }
                }
            },
            setDiffData() {
                var limits = globalStore.limits[globalStore.selectedIMO];

                if (typeof limits == 'undefined') {
                    limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
                }

                let cylCount = 6,
                    tcCount = 1;

                if (globalStore.selectedVessel != 'Energy Triumph')
                    tcCount = 2;

                let timeStamps = Object.keys(globalStore.signals);

                if (timeStamps.indexOf('average') > -1)
                    timeStamps.splice(timeStamps.indexOf('average'), 1);

                let params = ['pcomp', 'pmax', 'tcspeed', 'tscav', 'tTurbIn', 'pscav', 'soPresDispl', 'fRailPres'],
                    elCount = [cylCount, cylCount, tcCount, 0, tcCount, 0, 0, 0],
                    refs = ['pcomp', 'pmax', 'tcspeed', 'tscav', 'tTurbIn', 'pscav', 'soPresSetpoint', 'fRailPresSet'];

                for (let p = 0; p < params.length; p++) {
                    this.$set(this.chartData, params[p], {
                        credits: {enabled: false},
                        time: {
                            useUTC: false
                        },
                        chart: {
                            height: 100,
                            zoomType: 'xy'
                        },
                        xAxis: {
                            type: 'datetime',
                            labels: {
                                format: '{value:%H:%M}'
                            },
                            title:
                                {
                                    text: 'Time',
                                    align: 'high'
                                },
                            crosshair: true
                        },
                        yAxis: {
                            title:
                                {
                                    text: '[%]',
                                    align: 'high'
                                }
                        },
                        exporting: {
                            enabled: false
                        },
                        tooltip: {
                            formatter: function () {
                                return this.points.reduce(function (s, point) {
                                    if (point.series.type == 'line') {
                                        return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                                    }
                                    else {
                                        return s + '<br/>' + point.series.name + ': from ' + point.point.low.toFixed(2) + ' to ' + point.point.high.toFixed(2);
                                    }
                                }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
                            },
                            shared: true
                        },
                        legend: {
                            enabled: false
                        },
                        title: {
                            text: undefined
                        },
                        series: [
                            {
                                name: 'Difference %',
                                type: 'line',
                                color: 'transparent',
                                animation: false,
                                data: [],
                                marker: {
                                    radius: 3
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    },
                                    normal: {
                                        animation: false
                                    },
                                    inactive: {
                                        opacity: 1
                                    }
                                }
                            },
                            {
                                name: 'Acceptable Range',
                                type: 'arearange',
                                animation: false,
                                data: [],
                                marker: {
                                    enabled: false
                                },
                                color: 'rgb(219, 219, 219)',
                                fillOpacity: 0.6,
                                states: {
                                    hover: {
                                        enabled: false
                                    },
                                    normal: {
                                        animation: false
                                    },
                                    inactive: {
                                        opacity: 1
                                    }
                                }
                            }
                        ]
                    });

                    for (let i = 0; i < timeStamps.length; i++) {
                        let val, rfr;
                        if (elCount[p] == 0) val = globalStore.signals[timeStamps[i]][params[p]];
                        else val = this.average(params[p], elCount[p], globalStore.signals, timeStamps[i]);

                        if (params[p] == 'fRailPres') rfr = globalStore.signals[timeStamps[i]][refs[p]];
                        else if (Object.keys(globalStore.reference).includes(timeStamps[i])) {
                            if (elCount[p] == 0)
                                rfr = globalStore.reference[timeStamps[i]][refs[p]];
                            else
                                rfr = this.average(refs[p], elCount[p], globalStore.reference, timeStamps[i]);
                        } else
                            rfr = -1000;

                        let color = 'rgb(51,82,128)',
                            dt = new Date(timeStamps[i]);

                        if ((val != -1000) && (rfr != -1000) && (Object.keys(limits).includes(params[p]))) {
                            let minLimit = limits[params[p]][0], maxLimit = limits[params[p]][1];

                            let temp = ((val - rfr) / val) * 100;

                            if ((minLimit != null) && (maxLimit != null)) {

                                if ((temp > minLimit) && (temp < maxLimit)) color = 'rgb(60, 171, 48)';
                                else color = 'rgb(205, 57, 64)';

                                this.chartData[params[p]].series[1].data.push({
                                    x: dt,
                                    low: minLimit,
                                    high: maxLimit
                                });

                            }

                            this.chartData[params[p]].series[0].data.push({
                                x: dt,
                                y: temp,
                                color: color
                            });
                        }
                    }
                }

                if (globalStore.gasEngine) {
                    var vessel = Object.values(vessels.vessels).filter(function (i) {
                        return i.imo == globalStore.selectedIMO
                    })[0];

                    this.$set(this.chartData, 'gasMode', {
                        credits: {enabled: false},
                        time: {
                            useUTC: false
                        },
                        chart: {
                            height: 100,
                            zoomType: 'xy'
                        },
                        xAxis: {
                            type: 'datetime',
                            title: {
                                text: 'Time',
                                align: 'high'
                            },
                            labels: {
                                format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
                                rotation: 0
                            },
                            crosshair: true
                        },
                        yAxis: {
                            title: {
                                text: undefined
                            },
                            categories: ((vessel.control == 2) ? ['Diesel', 'Transfer', 'Gas', 'Gas-DCC', 'Diesel-fcmd'] : ['Diesel', 'Gas']) //Set Y axis based on the control system
                        },
                        exporting: {
                            enabled: false
                        },
                        tooltip: {
                            formatter: function () {
                                return this.points.reduce(function (s, point) {
                                    return s + '<br/>' + point.series.name + ': ' + point.series.yAxis.categories[point.y];
                                }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
                            },
                            shared: true
                        },
                        legend: {
                            enabled: false
                        },
                        title: {
                            text: undefined
                        },
                        series: [
                            {
                                name: 'Engine Mode',
                                type: 'line',
                                step: 'center',
                                color: 'rgb(51,82,128)',
                                animation: false,
                                data: [],
                                marker: {
                                    enabled: false
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    },
                                    normal: {
                                        animation: false
                                    },
                                    inactive: {
                                        opacity: 1
                                    }
                                }
                            },
                            {
                                name: 'State',
                                type: 'line',
                                color: 'transparent',
                                animation: false,
                                data: [],
                                marker: {
                                    radius: 0
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    },
                                    normal: {
                                        animation: false
                                    },
                                    inactive: {
                                        opacity: 1
                                    }
                                }
                            },
                        ]
                    });

                    this.$set(this.chartData, 'GasRailPress', {
                        credits: {enabled: false},
                        time: {
                            useUTC: false
                        },
                        chart: {
                            height: 100,
                            zoomType: 'xy'
                        },
                        xAxis: {
                            type: 'datetime',
                            title: {
                                text: 'Time',
                                align: 'high'
                            },
                            labels: {
                                format: ((typeof globalStore.dateTo == 'undefined' || globalStore.dateTo.length < 1) ? '{value:%H:%M}' : '{value:%m-%e}'),
                                rotation: 0
                            },
                            crosshair: true
                        },
                        yAxis: {
                            title: {
                                text: '[bar]',
                                align: 'high'
                            }
                        },
                        exporting: {
                            enabled: false
                        },
                        tooltip: {
                            formatter: function () {
                                return this.points.reduce(function (s, point) {
                                    if (point.series.type == 'line') {
                                        return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                                    }
                                    else {
                                        return s + '<br/>' + point.series.name + ': from ' + point.point.low.toFixed(2) + ' to ' + point.point.high.toFixed(2);
                                    }
                                }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
                            },
                            shared: true
                        },
                        legend: {
                            enabled: false
                        },
                        title: {
                            text: undefined
                        },
                        series: [
                            {
                                name: 'Fuel Side',
                                type: 'line',
                                color: 'transparent',
                                animation: false,
                                data: [],
                                marker: {
                                    radius: 3
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    },
                                    normal: {
                                        animation: false
                                    },
                                    inactive: {
                                        opacity: 1
                                    }
                                }
                            },
                            {
                                name: 'Exhaust Side',
                                type: 'line',
                                color: 'transparent',
                                animation: false,
                                data: [],
                                marker: {
                                    radius: 3
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    },
                                    normal: {
                                        animation: false
                                    },
                                    inactive: {
                                        opacity: 1
                                    }
                                }
                            },
                            {
                                name: 'Acceptable Range',
                                type: 'arearange',
                                animation: false,
                                data: [],
                                marker: {
                                    enabled: false
                                },
                                color: 'rgb(219, 219, 219)',
                                fillOpacity: 0.6,
                                states: {
                                    hover: {
                                        enabled: false
                                    },
                                    normal: {
                                        animation: false
                                    },
                                    inactive: {
                                        opacity: 1
                                    }
                                }
                            },
                            {
                                name: 'State',
                                type: 'line',
                                color: 'transparent',
                                animation: false,
                                data: [],
                                marker: {
                                    radius: 0
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    },
                                    normal: {
                                        animation: false
                                    },
                                    inactive: {
                                        opacity: 1
                                    }
                                }
                            },
                        ]
                    });

                    for (let i = 0; i < timeStamps.length; i++) {
                        let gas = globalStore.signals[timeStamps[i]]['gasOn'],
                            dt = new Date(timeStamps[i]),
                            fuel = globalStore.signals[timeStamps[i]]['GasRailPress1'],
                            exhaust = globalStore.signals[timeStamps[i]]['GasRailPress2'];

                        if (vessel.control == 2) {
                            this.chartData['gasMode'].series[0].data.push({x: dt, y: (globalStore.signals[timeStamps[i]]['fuelMode'] - 1)});
                        } else if (gas != -1000) {
                            if (gas == 0)
                                this.chartData['gasMode'].series[0].data.push({x: dt, y: 0});
                            else
                                this.chartData['gasMode'].series[0].data.push({x: dt, y: 1});
                        }

                        let rfr = -1000;

                        if (Object.keys(globalStore.signals[timeStamps[i]]).includes('GasRailPressSetPoint'))
                            rfr = globalStore.signals[timeStamps[i]]['GasRailPressSetPoint'];

                        let fuelColor = 'rgb(51,82,128)', exhColor = 'rgb(51,82,128)';

                        if (rfr != -1000 && Object.keys(limits).includes('GasRailPress')) {
                            let minLimit = limits['GasRailPress'][0], maxLimit = limits['GasRailPress'][1];

                            if ((minLimit != null) && (maxLimit != null)) {
                                let fuelTemp = ((fuel - rfr) / fuel) * 100,
                                    exhTemp = ((exhaust - rfr) / exhaust) * 100;

                                if ((fuelTemp > minLimit) && (fuelTemp < maxLimit))
                                    fuelColor = 'rgb(60, 171, 48)';
                                else
                                    fuelColor = 'rgb(205, 57, 64)';

                                if ((exhTemp > minLimit) && (exhTemp < maxLimit))
                                    exhColor = 'rgb(60, 171, 48)';
                                else
                                    exhColor = 'rgb(205, 57, 64)';

                                let min = rfr / (1 - minLimit / 100);
                                let max = rfr / (1 - maxLimit / 100);

                                this.chartData['GasRailPress'].series[2].data.push({
                                    x: dt,
                                    low: min,
                                    high: max
                                });
                            }
                        }

                        if (fuel != -1000)
                            this.chartData['GasRailPress'].series[0].data.push({
                                x: dt,
                                y: fuel,
                                color: fuelColor
                            });

                        if (exhaust != -1000)
                            this.chartData['GasRailPress'].series[1].data.push({
                                x: dt,
                                y: exhaust,
                                color: exhColor
                            });
                    }
                }
            }
        },
        computed: {
            dataLoaded: function () {
                return globalStore.type;
            },
            gasLayout: function () {
                return globalStore.gasEngine;
            }
        },
        watch: {
            dataType: function () {
                this.setData();
            },
            dataLoaded: function () {
                setTimeout(() => {
                    this.setData();
                });
            }
        }
    }
</script>

<style scoped>

</style>